import {useEffect} from "react";

export function useDomainSubscription(domain, eventType, listener) {
    useEffect(() => {
        const subscription = domain.on(eventType, listener)
        return () => {domain.off(subscription)}
    }, []);
}
